import React from "react";
import { Card, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
export default function EmptyMessage({
  text = "If you had results, they'd appear here.",
  title = "No results",
}) {
  const { t } = useTranslation();

  return (
    <Card>
      <Text fw={700}>{t("mixer:empty_message_title")}</Text>
      <Text size="sm" variant="subtle">
        {t("mixer:empty_message_text")}
      </Text>
    </Card>
  );
}
